module.exports = __webpack_public_path__ + "64bb0f9eae55569962723e9b7ea4537c.png";